import React, { FC, useCallback, useEffect } from 'react'
import { Tabs, Tab, Stack, Typography } from '@mui/material'
import { isUndefined } from 'lodash'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { NoYes } from '../../../types'
import { StyledTab } from '../../Common/StyledComponents'
import { ErrorSelectorMessage, StyledAppBar } from './StyledComponents'

export const YesNoSelector: FC<{
  name: string
  disabled?: boolean
  label: string
  mt?: number
  mb?: number
  yesOption?: NoYes
  noOption?: NoYes
}> = ({ name, disabled = false, label, mt = 0, mb = 0, yesOption, noOption }) => {
  const { t } = useTranslation()
  const { register, watch, setValue, errors } = useFormContext()

  const value = watch(name)
  const error = errors[name]

  const handleChange = useCallback(
    (_: React.ChangeEvent<unknown>, value: number) => {
      setValue(name, value, {
        shouldValidate: true,
        shouldDirty: true,
      })
    },
    [name, setValue],
  )

  useEffect(() => {
    register(name)
  }, [register])

  return (
    <Stack gap={2} mt={mt} mb={mb} data-test={`autotest-${name}`}>
      <Typography>{label}</Typography>
      <StyledAppBar position="static">
        <Tabs
          value={isUndefined(value) ? null : value}
          onChange={handleChange}
          indicatorColor="secondary"
        >
          <StyledTab value={noOption || false} label={t('no', 'No')} disabled={disabled} />
          <StyledTab value={yesOption || true} label={t('yes', 'Yes')} disabled={disabled} />
          <Tab value={null} sx={{ display: 'none' }} />
        </Tabs>
      </StyledAppBar>
      {error && <ErrorSelectorMessage variant="body1">{error.message}</ErrorSelectorMessage>}
    </Stack>
  )
}
